'use client';

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { SearchSm } from '@ethsign/icons';
import { CheckIcon } from '@radix-ui/react-icons';
import * as React from 'react';
import { useEffect, useRef } from 'react';
import { Button } from "../Button";
import { Popover, PopoverContent, PopoverTrigger } from "../Popover/popover";
import { cn } from "../lib/utils";
import { Command as CommandCore, CommandEmpty, CommandGroup, CommandInput, CommandItem } from "./command";
export var Combobox = function Combobox(_ref) {
  var _options$find;
  var options = _ref.options,
    placeholder = _ref.placeholder,
    emptyText = _ref.emptyText,
    className = _ref.className,
    value = _ref.value,
    onChange = _ref.onChange;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    open = _React$useState2[0],
    setOpen = _React$useState2[1];
  var ref = useRef(null);
  var _React$useState3 = React.useState(0),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    boxWidth = _React$useState4[0],
    setBoxWidth = _React$useState4[1];
  useEffect(function () {
    if (ref.current) {
      var _ref$current;
      setBoxWidth((_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.offsetWidth);
    }
  }, []);
  return /*#__PURE__*/React.createElement(Popover, {
    open: open,
    onOpenChange: setOpen
  }, /*#__PURE__*/React.createElement(PopoverTrigger, {
    asChild: true
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "outline",
    role: "combobox",
    "aria-expanded": open,
    className: cn('w-[200px] justify-start', className),
    ref: ref
  }, /*#__PURE__*/React.createElement(SearchSm, {
    className: "mr-2 h-4 w-4 shrink-0 opacity-50"
  }), value ? (_options$find = options.find(function (option) {
    return option.value === value;
  })) === null || _options$find === void 0 ? void 0 : _options$find.label : placeholder || 'Search')), /*#__PURE__*/React.createElement(PopoverContent, {
    className: "w-[200px] p-0",
    style: {
      width: "".concat(boxWidth, "px")
    }
  }, /*#__PURE__*/React.createElement(CommandCore, null, /*#__PURE__*/React.createElement(CommandInput, {
    placeholder: placeholder || 'Search',
    className: "h-9 border-none focus:outline-none focus:ring-0 focus:ring-transparent focus:shadow-none focus:border-input focus:ring-off"
  }), /*#__PURE__*/React.createElement(CommandEmpty, null, emptyText || 'Not found.'), /*#__PURE__*/React.createElement(CommandGroup, null, options.map(function (option) {
    return /*#__PURE__*/React.createElement(CommandItem, {
      value: option.value,
      key: option.value,
      onSelect: function onSelect(currentValue) {
        onChange === null || onChange === void 0 ? void 0 : onChange(currentValue === value ? '' : currentValue);
        setOpen(false);
      }
    }, option.label, /*#__PURE__*/React.createElement(CheckIcon, {
      className: cn('ml-auto h-4 w-4', value === option.value ? 'opacity-100' : 'opacity-0')
    }));
  })))));
};